// -------------- Hook to call the api endpoint for the OOF results ---------------
// ----------------------------------------------------------------------------------
// import functions and service
import { useState, useCallback } from 'react';
import { getOOFPredictions } from '../services/api';

// hook used to fetch OOF predictions from the backend API
export const useOOFResults = () => {

  // set all the states for the frontend to handle
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // callback function to run the API request to the backend and handle the response
  const loadOOF = useCallback(async ({ model, year }) => {

    // set the state to loading
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const data = await getOOFPredictions({ model, year }); // call the backend API
      setResult(data);

    } catch (err) { // catch any errors and set the error state
      console.error('Error loading OOF results:', err);
      setError(err.message || 'Failed to load CV results');

    } finally { // once it has finished stop loading
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []); // reset function to clear the result and error states

  return { result, loading, error, loadOOF, reset }; // return the states and functions to the frontend
};
